import {
    states,
    inmoneyadd,
    inbigwin,
    inwincount,
    inanim,
    set_inwincount,
    big_win, set_inanim, set_inmoneyadd, set_inbigwin, set_autospin_force_enabled, autospin_force, set_autospin_force
} from "../framework/src/engine/madnes/madnes_variables";
import {
    win,
    madnes_end_round,
    madnes_is_in_autostart,
    madnes_on_round_end,
    madnes_get_atomic_bet, madnes_win_anim_reset
} from "../framework/src/engine/madnes/madnes";
import {anims_money_add_win_anim, money_add_big_win_anim, start_standing_symbols} from "./ps_anims";

export function money_add_control()
{
    if(inmoneyadd || inbigwin)
    {
        setTimeout(function() {
            money_add_control();
        }, 100);
        return;
    }

    madnes_win_anim_reset(); //#
    // madnes_show_stop(); //#

    set_inwincount(false); //inwincount = false;

    if((win * 1 >= (madnes_get_atomic_bet()) * big_win))
    {
        ctrl_end_round_biwin();
        return;
    }


    if(win * 1 > 0)
    {
        money_add_win();
        return;
    }

    set_inanim(false); //inanim = 0;
    set_inmoneyadd(false); //inmoneyadd = 0;
    set_inbigwin(false); //inbigwin = 0;

    ctrl_end_round_nowin();
}

function ctrl_end_round_nowin() {

    madnes_end_round().then(() => {
        start_standing_symbols();
    });

    // madnes_end_round(true, {}, {}, function() {
    //
    //     // madnes_show_btns();
    //     // madnes_hide_stop();
    //     end_result_control();
    // });
}

function ctrl_end_round_win(addWin) {

    madnes_end_round().then(() => {
        start_standing_symbols();
    });

    // madnes_end_round(true, {}, {}, end_result_control);
}

function ctrl_end_round_biwin() {

    set_inbigwin(true); //inbigwin = 1;

    // madnes_hide_btns();
    // madnes_start_coin();

//	setTimeout(madnes_start_coin, 800);

    money_add_big_win_anim(win, false).then(function() {

        set_inmoneyadd(false); //inmoneyadd = 0;
        set_inbigwin(false); //inbigwin = 0;
        set_inanim(false); //inanim = 0;

        ctrl_end_round_win(win);
    });
}

function money_add_win()
{
    set_inmoneyadd(true); //inmoneyadd = 1;
    set_inbigwin(false); //inbigwin = 0;

    anims_money_add_win_anim(win).then(function () {

        set_inmoneyadd(false); //inmoneyadd = 0;
        set_inbigwin(false); //inbigwin = 0;
        set_inanim(false); //inanim = 0;

//         inmoneyadd = 0;
//         inanim = 0;
// //		win = 0;
//         inbigwin = 0;

        madnes_end_round();

        // return Promise.resolve();
        // ctrl_end_round_win(win);
    });
}

export function ctrl_end_round_freespins() {

    set_inbigwin(true); //inbigwin = 1;

    // madnes_hide_btns();
    // madnes_start_coin();

    return money_add_big_win_anim(win, true).then(function() {

        set_inmoneyadd(false); //inmoneyadd = 0;
        set_inbigwin(false); //inbigwin = 0;
        set_inanim(false); //inanim = 0;

        return Promise.resolve();

        // madnes_end_round();

        // madnes_end_round(true, {}, { fsWin, fsOrder, fsCount }, function() {
        //
        //     //madnes_set_cookie("lfspos_" + server_config.session_id, "", -1);
        //     end_result_control();
        // });
    });
}

function end_result_control()
{
    // madnes_on_round_end();
    //
    // // // madnes_on_end_round_recount(win);
    // // madnes_on_round_end();
    // // madnes_recount_bet();
    // //
    // // // madnes_show_btns();
    // // // madnes_hide_spin();
    //
    // // set_autospin_force_enabled(false); //set_autospin_force_enabled = false;
    // // if(madnes_is_in_autostart() || autospin_force)
    // // {
    // //     set_autospin_force(false); //autospin_force = false;
    // //     madnes_rotate_start();
    // //     return;
    // // }
    // //
    // // states.setState(STATES.IDLE);
    //
    // //setTimeout(start_standing_symbols, won ? 3000 : 400);
    //
    //
    //
    // // start_standing_symbols();
}